module.exports = __webpack_public_path__ + "static/media/slider_background.bf91a02a.svg";